const conferenceRoomSx = {
  root: {
    height: {
      xs: 'calc(100vh - 56px)',
      sm: 'calc(100vh - 64px)',
    },
    width: '100%',
    position: 'relative',
  },

  backArrowBox: {
    cursor: 'pointer',
    position: 'absolute',
    top: { xs: 45, sm: 55 },
    left: { xs: 10, sm: 15 },
    zIndex: 10,
  },

  loadingOverlay: {
    height: '100%',
    backgroundColor: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    m: 4,
  },
}

export default conferenceRoomSx